/**
 * ChatBubbleButton - Minimized chat bubble button
 * Shows unread count badge
 */

import { MessageCircle } from 'lucide-react'
import { useChat } from '../../contexts/ChatContext'

export default function ChatBubbleButton() {
  const { toggleBubble, totalUnreadCount } = useChat()

  return (
    <button
      onClick={toggleBubble}
      className="relative bg-primary hover:bg-primary-600 text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105 group"
      aria-label="Open chat"
    >
      <MessageCircle className="w-6 h-6" />

      {totalUnreadCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full min-w-[20px] h-5 flex items-center justify-center px-1.5 animate-pulse">
          {totalUnreadCount > 9 ? '9+' : totalUnreadCount}
        </span>
      )}

      {/* Pulse animation for unread messages */}
      {totalUnreadCount > 0 && (
        <span className="absolute inset-0 rounded-full bg-primary animate-ping opacity-20" />
      )}

      {/* Tooltip */}
      <span className="absolute bottom-full right-0 mb-2 px-3 py-1 bg-gradient-to-r from-[#fe395f] to-[#ff7a9a] text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none shadow-lg">
        Messages
        {totalUnreadCount > 0 && ` (${totalUnreadCount} unread)`}
      </span>
    </button>
  )
}
